module.exports = __webpack_public_path__ + "47cb1896dc91ee9b0a077b5a2e4909f3.png";